DomObserver.observe('.js-default-appointment', blocks => {
  blocks.forEach(block => {
    // Find the select element
    const select = block.querySelector('select');
    select.addEventListener('change', () => {
      if (!select.value) return;

      // Redirect to the selected value
      window.location.href = select.value;
    });
  });
});